import * as React from 'react';

import * as styles from './theme.module.scss';

export const pageThemes = ['beige', 'white'] as const;

export interface PageThemeProps {
  children: React.ReactNode[] | React.ReactNode;
  theme: (typeof pageThemes)[number];
}

const PageTheme = ({children, theme}: PageThemeProps) => {
  return (
    <div
      className={`${styles.wrapper} ${styles[theme]}`}
      id="content"
      tabIndex={-1}>
      {children}
    </div>
  );
};

export default PageTheme;
